import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import React from 'react';
import { Base, Tooltip, Typography } from 'lib/cortiUI';
export const CardTitle = ({ text, tooltip }) => {
    return (React.createElement(Base, { display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between" },
        React.createElement(Typography, { variant: "body1", color: "default" }, text),
        tooltip && (React.createElement(Tooltip, { title: tooltip, sx: { cursor: 'help' } },
            React.createElement(InfoRoundedIcon, { fontSize: "small", color: "disabled" })))));
};
